<div class="mr-3 mt-2 justify-class-end ">
  <button pButton type="button" icon="pi pi-refresh" class="p-button-secondary" (click)="reload()"></button>
</div>
<div *ngIf="mostrarDiv" class="shadow-8" style="padding: 5px 16px 14px 17px;">
  <p-toolbar>
    <div class="p-toolbar-group-left col-7">
      <p>
        {{texto}}
      </p>
    </div>
    <div class="-mt-1 justify-class-end col-5">
      <div class="p-toolbar-group-right mr-4">
        <button pButton type="button" label="Atualizar agora" class="p-button-azul ml-5" icon="pi pi-download"
          (click)="atualizarAgora()"></button>
        <p-confirmDialog header="Confirmação" icon="pi pi-exclamation-triangle"></p-confirmDialog>
      </div>
      <div class="p-toolbar-group-right">
        <p-button label="Agendar atualização" icon="pi pi-undo" (click)="agendar()"></p-button>
      </div>
    </div>

  </p-toolbar>
</div>

<div class="shadow-8" style="padding: 6px 16px 0px 14px;">
  <p-table [columns]="cols" [value]="dadosAtualizacao"
    styleClass="p-datatable-responsive-demo p-datatable-striped p-datatable-sm" selectionMode="single"
    [loading]="loading" [columns]="cols" [autoLayout]="true" [rows]="10">
    <ng-template pTemplate="header" let-columns>
      <tr>
        <th *ngFor="let col of columns" style="background: black; color: mintcream;" [pSortableColumn]="col.field">
          <span *ngIf="col.field === 'status'" pTooltip="Amarela = PENDENTE, Verde = CONCLUIDO, Azul = APROVADO" tooltipPosition="top">
            {{col.header}}
          </span>
          <span *ngIf="col.field !== 'status'">
            {{col.header}}
          </span>
          <p-sortIcon [field]="col.field" style="color: mintcream;"></p-sortIcon>
        </th>
      </tr>
    </ng-template>
    
    <ng-template pTemplate="body" let-rowData let-columns="columns">
      <tr>
        <td *ngFor="let col of columns">
          <ng-container *ngIf="col.field === 'status'">
            <div pTooltip="{{ getStatusMessage(rowData[col.field]) }}" tooltipPosition="top">
              <i class="fa fa-circle"
                [ngClass]="{
                  'text-warning': rowData[col.field] === 'PENDENTE',
                  'text-primary': rowData[col.field] === 'APROVADO',
                  'text-success': rowData[col.field] === 'CONCLUIDO'
                }"></i>
            </div>
          </ng-container>
          <ng-container *ngIf="col.field !== 'status'">
            {{ rowData[col.field] }}
          </ng-container>
        </td>
      </tr>
    </ng-template> 

  </p-table>
  <div *ngIf="mostrarPaginador">
    <p-paginator [rows]="size" [totalRecords]="totalRecords" [rowsPerPageOptions]="[10,20,30,50,100]"
      (onPageChange)="carregarDadosLazy($event)" [showCurrentPageReport]="true"
      currentPageReportTemplate="Mostrando {first} à {last} de {totalRecords} registros">
    </p-paginator>
  </div>

</div>